import { createContext } from 'react';

import type { BaseGroup, BaseItem, PickListContextValue } from './type';

export const PickListContext = createContext<PickListContextValue<
  BaseItem,
  BaseGroup<BaseItem>
> | null>(null);
